import Vue from 'vue';
import 'whatwg-fetch';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPersonWalking, faStairs, faTimes } from '@fortawesome/free-solid-svg-icons';
import VueI18n from 'vue-i18n';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import pl from '@/trans/pl.json';
import en from '@/trans/en.json';
import fr from '@/trans/fr.json';
import es from '@/trans/es.json';
import App from './App.vue';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        dsn: 'https://72c64d3edabe41d6a67e41dbb2f0015e@o522645.ingest.sentry.io/4504875996938240',
        integrations: [new BrowserTracing()],
        tracesSampleRate: 0.1,
    });
}

library.add(faPersonWalking, faTimes, faStairs);

dom.watch();

Vue.config.productionTip = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
    messages: {
        en, pl, fr, es,
    },
    locale: Intl.DateTimeFormat().resolvedOptions().locale.slice(0, 2) || navigator.language.slice(0, 2),
});

new Vue({
    i18n,
    render: (h) => h(App),
}).$mount('#app');
